import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=3923b154"
import script from "./Filters.vue?vue&type=script&lang=js"
export * from "./Filters.vue?vue&type=script&lang=js"
import style0 from "./Filters.vue?vue&type=style&index=0&id=3923b154&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports